import RadioInput from '@rsa-digital/evo-shared-components/components/Form/RadioInput';
import { RadioItem } from '@rsa-digital/evo-shared-components/components/Form/RadioInput/styles';
import mediaQuery from '@rsa-digital/evo-shared-components/helpers/mediaQuery';
import styled from 'styled-components';

export const StyledRadioInput = styled(RadioInput)`
  ${RadioItem} {
    ${mediaQuery.tabletLandscape`
      max-width: 544px;
  `}
  }
`;
